import { Typography } from "antd";
import { clsx } from "clsx";

import { RVIcon, RVIconSizeOptions } from "@regal-voice/ui";
import { SharedBlockProps } from "Components/elements/RVFlow/RVFlowTypes";
import { BlockContainer } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContainer/BlockContainer";
import { BlockContent } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContent/BlockContent";
import { BlockTitle } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockTitle/BlockTitle";
import {
    getJourneyNodeIcon,
    getJourneyNodeTypeConfig,
} from "Components/elements/RVFlow/Shared/JourneyNodePresentation";
import { NodeType } from "Types/Journey";

import { DecisionAIFormItemKeys } from "../../../../Components/JourneyActionsPanel/NodeEditorPanel/Components/_DemoFormItems/constants";
import { useJourneyBlockData } from "../../Shared/Hooks/useJourneyBlockData/useJourneyBlockData";

import styles from "./DecisionAIBlock.module.scss";

const BLOCK_TITLE = "Regal AI Action";
const NODE_TITLE = "AI Decision";
const NODE_PROMPT = "Configure AI Decision";

const BLOCK_VARIANT = getJourneyNodeTypeConfig(NodeType.DecisionAI).variant;
const BLOCK_ICON = getJourneyNodeIcon(NodeType.DecisionAI);

export function DecisionAIBlock({ data, variant }: SharedBlockProps): JSX.Element {
    const { [DecisionAIFormItemKeys.name]: name, [DecisionAIFormItemKeys.variants]: variants } = data || {};

    const isNodeConfigured = !!name;
    const hasVariants = !!variants?.variant1;
    const isBlock = variant === "block";

    const { fallBackTitle, isActive, nodeName } = useJourneyBlockData({
        variant,
        isNodeConfigured,
        preferedNodeName: `${name}`,
        blockTitle: BLOCK_TITLE,
        nodeTitle: NODE_TITLE,
        nodePropmpt: NODE_PROMPT,
    });

    return (
        <BlockContainer contentClassName={styles.decisionAiContent} variant={BLOCK_VARIANT} icon={BLOCK_ICON}>
            <BlockTitle
                nodeData={data}
                fallBackDisplay={fallBackTitle}
                iconClassName={styles.sparkleIcon}
                icon={<RVIcon icon="sparkle" size={RVIconSizeOptions.XSMALL} />}
            />

            <BlockContent
                isActive={isActive}
                className={clsx({
                    [styles.decisionAiNode]: hasVariants,
                    [styles.nonEmpty]: !isBlock && isActive,
                })}
            >
                <Typography.Text>{nodeName}</Typography.Text>
            </BlockContent>
        </BlockContainer>
    );
}
